export default __webpack_public_path__ + "static/media/contato-form-cima.27a83342.svg";